import { Stack } from "@mui/material";
import { useState } from "react";
import { WifiKeyDto } from "../../dtos/WifiKeyDto";
import { WifiDetails } from "./WifiDetails";
import { EnterDeviceDetails } from "./EnterDeviceDetails";


export const DeviceWifiKey: React.FC = () => {

    const [ wifiKey, setWifiKey ] = useState< WifiKeyDto >( );

    const handleSetWifiKey = ( wifiKeyDto : WifiKeyDto | undefined ) => {

        setWifiKey( wifiKeyDto );

    };

    return(

        <Stack justifyContent="center" spacing={ 3 } sx={{ alignItems :"center" }}>

            <EnterDeviceDetails onSetWifiKey={ handleSetWifiKey } />

            { wifiKey  && <WifiDetails wifiKeyDto={ wifiKey } /> }

        </Stack>

    );

};